import styled from "styled-components";

export const Title = styled("h3")`
  font-size: 24px;
  font-weight: 300;
  color: #74767d;
  padding: 0;
  margin: 0 0 4px;
`;
